import React from "react";
import styled from "styled-components";
import {NavLink} from "react-router-dom";

export default function ItemMenu({name, path, Icon, back}) {
   return (
      <>
         <Item to={path || "/"} activeClassName="current" back={back}>
            <Icon width="2.5em" height="2.5em" className="icon" />
            <span>{name}</span>
         </Item>
      </>
   );
}

const Item = styled(NavLink)`
   font-size: 0.8rem;
   width: 100%;
   display: flex;
   justify-content: center;
   align-items: center;
   flex-direction: column;
   padding: 1em 0;
   box-sizing: border-box;
   border-bottom: 1px solid grey;
   border-right: 1px solid #1c355e;

   &:first-child {
      border-top: 1px solid grey;
   }

   text-decoration: none;
   text-transform: capitalize;
   font-weight: 100;
   color: #1c355e;
   transition: color 120ms ease, background 420ms linear;

   span {
      margin-top: 0.5em;
      display: block;
      text-align: center;
      transition: color 120ms ease, background 420ms linear;
      &.min {
         font-size: 0.8em;
      }
   }

   .icon {
      fill: #1c355e;
      transition: fill 420ms ease;
   }

   &.current {
      color: white;
      background-color: ${props => props.back};
      border-bottom-color: ${props => props.back};
      transition: color 120ms ease, background 420ms linear;

      .icon {
         fill: white;
         transition: fill 420ms ease;

         //  stroke: white;
      }
   }
`;
